import React from 'react';
import './RedirectToPage2.css';
import Button from '../Button/Button';

const RedirectToPage2 = ({ link, title, details, ButtonText }) => {
  return (
    <div className="RedirectToPage2-container">
      <hr className='RedirectToPage2-line'/>
      <div className="RedirectToPage2-content">
        <h2 className="RedirectToPage2-title">{title}</h2>
        <p className="RedirectToPage2-details">{details}</p>
        <Button to={link} children={ButtonText} />
      </div>
    </div>
  );
};


export default RedirectToPage2;
